export const FETCH_LOAD_DETAILS = 'FETCH_LOAD_DETAILS'
export const FETCH_LOAD_ACCEPTS = 'FETCH_LOAD_ACCEPTS'
export const FETCH_LOAD_NEGOTIATIONS = 'FETCH_LOAD_NEGOTIATIONS'
export const FETCH_LOAD_BIDS = 'FETCH_LOAD_BIDS'
export const FETCH_LOAD_HISTORY = 'FETCH_LOAD_HISTORY'
export const FETCH_LOAD_ITNERARY = 'FETCH_LOAD_ITNERARY'
export const CLEAR_FOUND_DRIVER = 'CLEAR_FOUND_DRIVER'
export const FIND_DRIVER_BY_CPF = 'FIND_DRIVER_BY_CPF'
export const FIND_DRIVER_BY_NAME = 'FIND_DRIVER_BY_NAME'
export const FIND_DRIVER_BY_NAME_NOT_FOUND = 'FIND_DRIVER_BY_NAME_NOT_FOUND'
export const FIND_DRIVER_BY_CPF_TO_REGISTER = 'FIND_DRIVER_BY_CPF_TO_REGISTER'
export const FIND_VEHICLE_BY_PLATE = 'FIND_VEHICLE_BY_PLATE'
export const LOAD_ACCEPT = 'LOAD_ACCEPT'
export const FETCH_LOAD_INCIDENTS = 'FETCH_LOAD_INCIDENTS'
export const FETCH_INCIDENT_IMAGE = 'FETCH_INCIDENT_IMAGE'
export const FETCH_LOAD_RECEIPT_BY_DELIVERY = 'FETCH_LOAD_RECEIPT_BY_DELIVERY'
export const CLEAR_DELIVERY_RECEIPTS = 'CLEAR_DELIVERY_RECEIPTS'
export const FETCH_LOAD_FILES_BY_ATTACHMENT = 'FETCH_LOAD_FILES_BY_ATTACHMENT'
export const CLEAR_LOAD_FILES_BY_ATTACHMENT = 'CLEAR_LOAD_FILES_BY_ATTACHMENT'
export const FETCH_LOAD_ATTACHMENTS = 'FETCH_LOAD_ATTACHMENTS'
export const FETCH_LOGISTIC_OPERATORS = 'FETCH_LOGISTIC_OPERATORS'
export const FETCH_INCIDENT_TYPES = 'FETCH_INCIDENT_TYPES'
export const HANDLE_ENABLE_TRACKING_DEVICE = 'HANDLE_ENABLE_TRACKING_DEVICE'
export const MAPPED_TRACKING_DEVICE_FIELDS = 'MAPPED_TRACKING_DEVICE_FIELDS'
export const CHANGE_TRACKING_DEVICE_FIELDS = 'CHANGE_TRACKING_DEVICE_FIELDS'
export const CLEAR_TRACKING_DEVICE_FIELDS = 'CLEAR_TRACKING_DEVICE_FIELDS'
export const CHANGE_VEHICLE_TO_BIND = 'CHANGE_VEHICLE_TO_BIND'
export const GET_ALL_PENDINGS_BY_SHIPPING = 'GET_ALL_PENDINGS_BY_SHIPPING'
export const GET_ALL_PENDINGS_TYPES = 'GET_ALL_PENDINGS_TYPES'
export const TOGGLE_PENDING_DRAWER_VISIBLE = 'TOGGLE_PENDING_DRAWER_VISIBLE'
export const NEW_PENDING_UPDATE = 'NEW_PENDING_UPDATE'
export const CLEAR_DRIVER_TO_BIND = 'CLEAR_DRIVER_TO_BIND'
export const CLEAR_VEHICLE_TO_BIND = 'CLEAR_VEHICLE_TO_BIND'
export const SELECT_ORDER_BY_CODE = 'SELECT_ORDER_BY_CODE'
export const ORDER_IS_LOADING = 'ORDER_IS_LOADING'
